export default __webpack_public_path__ + "static/media/zitel-logo.9330cb4f.svg";